import { FormikDropzone } from './view';
export default FormikDropzone;
